<script>
import { Line } from "vue-chartjs";

export default {
    name: "LineChart",
    extends: Line,
    props: {
        title: {
            type: String,
            default: null,
        },
        labels: {
            type: Array,
            default: () => [],
        },
        datasets: {
            type: Array,
            default: () => [],
        },
        minY: {
            type: [String, Number],
            default: undefined,
        },
        maxY: {
            type: [String, Number],
            default: undefined,
        },
    },
    computed: {
        data(vm = this) {
            return {
                labels: vm.labels,
                datasets: vm.datasets,
            }
        },
        options(vm = this) {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [
                        {
                            id: 'left-axis',
                            type: 'linear',
                            position: 'left',
                            ticks: {
                                beginAtZero: true,
                                min: vm.minY,
                                max: vm.maxY,
                            },
                        },
                        ...(vm.hasRightAxis
                            ? [{
                                id: 'right-axis',
                                type: 'linear',
                                position: 'right',
                                ticks: {
                                    beginAtZero: true,
                                    min: vm.minY,
                                    max: vm.maxY,
                                },
                                gridLines: {
                                    display: false,
                                },
                            }]
                            : [])
                    ],
                    xAxes: [{
                        gridLines: {
                            display: false
                        },
                    }],
                },
                legend: {
                    display: false,
                },
                title: {
                    display: !!vm.title,
                    text: vm.title
                },
                layout: {
                    padding: {
                        // top: 26,
                    }
                },
            }
        },
        hasRightAxis(vm = this) {
            return vm.datasets.some(dataset => dataset.yAxisID === 'right-axis')
        }
    },
    mounted() {
        const vm = this
        vm.renderChart(vm.data, vm.options);
    },
    watch: {
        data() {
            const vm = this
            vm.renderChart(vm.data, vm.options);
        },
        options() {
            const vm = this
            vm.renderChart(vm.data, vm.options);
        }
    }
};
</script>